import { api } from "@/api/client";
import { unwrap } from "@/api/errors";
import type { V2Project } from "../types";

export { listReferences } from "@/api/reference-actions";

export async function updateProjectSettings(project: V2Project, name: string, visibility: V2Project["visibility"]) {
  return unwrap(await api.PATCH("/v1/projects/{id}", { params: { path: { id: project.id } },
    body: { expected_version: project.version, name, visibility } }));
}

export { linkProjectContent } from "@/api/projects";
